import { observable, makeObservable, action } from 'mobx';

export default class ErrorHandlingStore {
    constructor() {
        makeObservable(this, {
            error: observable,
            handleError: action
        });
    }

    error: Error | undefined;

    handleError = (error: Error) => {
        this.error = error;
    };
}
